import React from 'react';
import { PublicFooter } from './PublicFooter';

export const LandingFooter: React.FC = () => <PublicFooter />;
